import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 322 322"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M320 160c0 88.37-71.63 160-160 160S0 248.37 0 160 71.63 0 160 0s160 71.63 160 160Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FDFDFF",
      d: "M150 51a16 16 0 0 0-16 16v21a16 16 0 0 0 16 16h19a16 16 0 0 0 16-16V67a16 16 0 0 0-16-16h-19Zm0 79a16 16 0 0 0-16 16v115a16 16 0 0 0 16 16h19a16 16 0 0 0 16-16V146a16 16 0 0 0-16-16h-19Z"
    }, null, -1)
  ])))
}
export default { render: render }